/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import shallow from 'zustand/shallow';

import { Episode, EpisodeSection, User } from '../../../@types';
import * as Constants from '../../../constants';
import { EpisodeVideoBase } from '../../episode-video';
import { useEpisodeStore } from '../../../store';
import { EpisodeEndScreen } from './EpisodeEndScreen';

interface EpisodeProps {
  currentSection: EpisodeSection;
  episode: Episode;
}

const EpisodeSectionWrapper = styled.div`
  width: 100%;
`;

const EpisodeWrapper: React.FC<EpisodeProps> = ({
  episode,
  currentSection,
}) => {
  const actionsRef = useRef(useEpisodeStore.getState().EPISODE_ACTIONS);
  const EPISODE_ACTIONS = actionsRef.current;
  const { showEndScreen } = useEpisodeStore(
    (state) => ({
      showEndScreen: state.showEndScreen,
    }),
    shallow
  );
  const currentSectionIdx = episode.sections
    ? episode.sections.findIndex(({ id }) => id === currentSection?.id)
    : -1;

  const currentEpisodeIdx = episode.series?.series_episodes?.findIndex(
    ({ id }: any) => id === episode.id
  );
  const nextEpisode =
    currentEpisodeIdx !== -1 &&
    episode.series?.series_episodes?.[currentEpisodeIdx + 1];

  useEffect(() => {
    EPISODE_ACTIONS.initEpisode(episode, currentSection.id, 0);
  }, [currentSection]);

  return (
    <div>
      {currentSection && (
        <EpisodeSectionWrapper key={currentSection.id}>
          {currentSection.section_type ===
            Constants.EPISODE_SECTION_TYPES.VIDEO &&
            currentSection.video_src && (
              <EpisodeVideoBase
                initial_timestamp={0}
                section={currentSection}
              />
            )}
        </EpisodeSectionWrapper>
      )}
      <EpisodeEndScreen
        hide={() => EPISODE_ACTIONS.setShowEndScreen(false)}
        show={showEndScreen}
        nextEpisode={nextEpisode}
        sections={episode.sections}
        currentSectionIdx={currentSectionIdx}
      />
    </div>
  );
};
export default EpisodeWrapper;
